import React, { useState, useEffect } from "react";

const FadeAnimation = ({ textList, fadeDuration = 1000, pauseTime = 4000 }) => {
  const [textIndex, setTextIndex] = useState(0);
  const [opacity, setOpacity] = useState(1);

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity(0); // Start fade out
      setTimeout(() => {
        setTextIndex((prev) => (prev + 1) % textList.length); // Change text
        setOpacity(1); // Fade in
      }, fadeDuration);
    }, pauseTime + fadeDuration);

    return () => clearInterval(interval);
  }, [textIndex, fadeDuration, pauseTime, textList]);

  return (
    <span
      style={{
        opacity,
        transition: `opacity ${fadeDuration}ms ease-in-out`,
      }}
    >
      {textList[textIndex]}
    </span>
  );
};

export default FadeAnimation;
